import React, { useState, useEffect, useRef } from "react";
import { getData, postData, serverURL } from "../../../Services/Fetchnodeservices";

// ─────────────────────────────────────────────────────────────────────────────
// ICONS (same as before - keeping it concise)
// ─────────────────────────────────────────────────────────────────────────────
const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const EyeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const DeleteIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const HideIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const ShowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const UploadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const RefreshIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M23 4v6h-6" />
    <path d="M1 20v-6h6" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10" />
    <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14" />
  </svg>
);

const SpinnerIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" style={{ animation: "spin 0.8s linear infinite", transformOrigin: "center" }} />
  </svg>
);

// ─────────────────────────────────────────────────────────────────────────────
// ADD WEB BANNER DIALOG COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const AddWebBannerDialog = ({ isDark, onClose, onSave, editingBanner }) => {
  const [formData, setFormData] = useState({
    title: editingBanner?.title || "",
    hide: editingBanner?.hide === 0 ? "Show" : "Hide",
  });
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(editingBanner?.pic ? getImageUrl(editingBanner.pic) : null);
  const [dragActive, setDragActive] = useState(false);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  function getImageUrl(picName) {
    if (!picName || picName.trim() === "" || picName === "NULL" || picName === "null") {
      return null;
    }
    let filename = picName;
    if (filename.includes('/')) {
      filename = filename.split('/').pop();
    }
    return `${serverURL}/uploads/${filename}`;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (file) => {
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    handleImageChange(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      handleImageChange(file);
    }
  };

  const uploadImage = async (file) => {
    if (!file) return null;
    
    const formDataImg = new FormData();
    formDataImg.append("pic", file);
    
    try {
      const response = await postData("banners/webbanner", formDataImg, "multipart/form-data");
      if (response && response.status === true && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error("Image upload error:", error);
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.title.trim()) {
      alert("Please enter banner title");
      return;
    }
    
    setUploading(true);
    
    let uploadedImagePath = editingBanner?.pic || null;
    
    if (imageFile) {
      const uploadedPath = await uploadImage(imageFile);
      if (uploadedPath) {
        uploadedImagePath = uploadedPath;
      }
    }
    
    const bannerData = {
      title: formData.title,
      hide: formData.hide === "Hide" ? 1 : 0,
      pic: uploadedImagePath,
    };
    
    onSave(bannerData, editingBanner);
    setUploading(false);
    onClose();
  };

  const dialogStyles = {
    overlay: {
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.7)", display: "flex", alignItems: "center",
      justifyContent: "center", zIndex: 1000, backdropFilter: "blur(4px)",
    },
    dialog: {
      width: "90%", maxWidth: "560px", background: isDark ? "#141824" : "#ffffff",
      borderRadius: "20px", boxShadow: "0 25px 40px -12px rgba(0,0,0,0.4)",
      overflow: "hidden", animation: "fadeIn 0.2s ease-out",
    },
    header: {
      display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "18px 24px", borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
    },
    title: {
      fontSize: "20px", fontWeight: 700, color: isDark ? "#f1f5f9" : "#0f172a", margin: 0,
    },
    closeBtn: {
      background: "none", border: "none", cursor: "pointer", color: isDark ? "#94a3b8" : "#64748b",
      padding: "4px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "8px",
    },
    body: { padding: "24px", maxHeight: "65vh", overflowY: "auto" },
    formGroup: { marginBottom: "20px" },
    label: {
      display: "block", marginBottom: "8px", fontSize: "13px", fontWeight: 600,
      color: isDark ? "#cbd5e1" : "#334155",
    },
    required: { color: "#ef4444", marginLeft: "4px" },
    input: {
      width: "100%", padding: "12px 14px", background: isDark ? "#0d1117" : "#f8fafc",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "12px",
      fontSize: "14px", color: isDark ? "#f1f5f9" : "#1e293b", outline: "none",
      transition: "all 0.2s", boxSizing: "border-box",
    },
    imageUploadArea: {
      border: `2px dashed ${dragActive ? '#3b82f6' : (isDark ? '#1e2740' : '#e2e8f0')}`,
      borderRadius: "16px", padding: "24px", textAlign: "center", cursor: "pointer",
      transition: "all 0.2s", background: isDark ? "rgba(59,130,246,0.05)" : "rgba(59,130,246,0.02)",
      marginTop: "8px",
    },
    imagePreview: { width: "100%", maxHeight: "160px", objectFit: "cover", borderRadius: "12px", marginTop: "16px" },
    uploadIcon: { display: "flex", justifyContent: "center", marginBottom: "12px" },
    uploadText: { fontSize: "14px", fontWeight: 500, color: isDark ? "#94a3b8" : "#64748b", marginBottom: "6px" },
    uploadHint: { fontSize: "11px", color: isDark ? "#4a5568" : "#94a3b8" },
    radioGroup: { display: "flex", gap: "24px", marginTop: "8px" },
    radioLabel: { display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "14px", color: isDark ? "#f1f5f9" : "#1e293b" },
    radio: { width: "16px", height: "16px", cursor: "pointer" },
    footer: {
      display: "flex", justifyContent: "flex-end", gap: "12px", padding: "16px 24px",
      borderTop: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", background: isDark ? "#0f1520" : "#fafcff",
    },
    cancelBtn: {
      padding: "10px 20px", background: "transparent", border: isDark ? "1px solid #2a3a5a" : "1px solid #cbd5e1",
      borderRadius: "10px", fontSize: "14px", fontWeight: 500, color: isDark ? "#94a3b8" : "#475569", cursor: "pointer",
    },
    saveBtn: {
      padding: "10px 24px", background: uploading ? "#94a3b8" : "#4a6cf7", border: "none",
      borderRadius: "10px", fontSize: "14px", fontWeight: 600, color: "#fff", cursor: uploading ? "not-allowed" : "pointer",
    },
  };

  return (
    <div style={dialogStyles.overlay} onClick={onClose}>
      <div style={dialogStyles.dialog} onClick={(e) => e.stopPropagation()}>
        <div style={dialogStyles.header}>
          <h3 style={dialogStyles.title}>{editingBanner ? "Edit Banner" : "Add Banner"}</h3>
          <button style={dialogStyles.closeBtn} onClick={onClose}><CloseIcon /></button>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={dialogStyles.body}>
            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Banner Name <span style={dialogStyles.required}>*</span></label>
              <input type="text" name="title" style={dialogStyles.input} placeholder="Enter banner name" value={formData.title} onChange={handleChange} required autoFocus />
            </div>

            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Image</label>
              <div style={dialogStyles.imageUploadArea} onClick={() => fileInputRef.current?.click()} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop}>
                <input ref={fileInputRef} type="file" accept="image/png, image/jpeg, image/jpg, image/webp" onChange={handleFileInput} style={{ display: "none" }} />
                <div style={dialogStyles.uploadIcon}><UploadIcon /></div>
                <div style={dialogStyles.uploadText}>{imagePreview ? "Change Image" : "Click or drag image here"}</div>
                <div style={dialogStyles.uploadHint}>PNG, JPG, WebP up to 10MB</div>
                {imagePreview && <img src={imagePreview} alt="Preview" style={dialogStyles.imagePreview} />}
              </div>
            </div>

            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Visibility</label>
              <div style={dialogStyles.radioGroup}>
                <label style={dialogStyles.radioLabel}>
                  <input type="radio" name="hide" value="Show" checked={formData.hide === "Show"} onChange={handleChange} style={dialogStyles.radio} /> Show
                </label>
                <label style={dialogStyles.radioLabel}>
                  <input type="radio" name="hide" value="Hide" checked={formData.hide === "Hide"} onChange={handleChange} style={dialogStyles.radio} /> Hide
                </label>
              </div>
            </div>
          </div>
          <div style={dialogStyles.footer}>
            <button type="button" style={dialogStyles.cancelBtn} onClick={onClose}>Cancel</button>
            <button type="submit" style={dialogStyles.saveBtn} disabled={uploading}>{uploading ? "Uploading..." : (editingBanner ? "Update Banner" : "Save Banner")}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// SUB-COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────

const StatusBadge = ({ hide, isDark }) => {
  const isVisible = hide === 0;
  const config = isVisible 
    ? { bg: isDark ? "rgba(34,197,94,0.15)" : "rgba(34,197,94,0.1)", color: "#22c55e", text: "Visible" }
    : { bg: isDark ? "rgba(148,163,184,0.12)" : "rgba(148,163,184,0.08)", color: "#94a3b8", text: "Hidden" };
  return (
    <span style={{ display: "inline-block", padding: "4px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: config.bg, color: config.color }}>
      {config.text}
    </span>
  );
};

const ImagePlaceholder = ({ isDark, imageUrl, title }) => {
  const getImageUrl = (picName) => {
    if (!picName || picName.trim() === "" || picName === "NULL" || picName === "null") return null;
    let filename = picName;
    if (filename.includes('/')) filename = filename.split('/').pop();
    return `${serverURL}/uploads/${filename}`;
  };
  
  const imgUrl = imageUrl ? getImageUrl(imageUrl) : null;
  
  return (
    <div style={{
      width: "48px", height: "48px", borderRadius: "10px",
      background: isDark ? "#1e2740" : "#f1f5f9",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: "20px", border: isDark ? "1px solid #2a3145" : "1px solid #e2e8f0",
      overflow: "hidden",
    }}>
      {imgUrl ? (
        <img src={imgUrl} alt={title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      ) : (
        "🖼️"
      )}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const WebBanners = ({ isDark = true }) => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingBanner, setEditingBanner] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const itemsPerPage = 10;

  // ✅ Fetch banners
  const fetchBanners = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getData("banners/fetch_webbanner");
      console.log("API Response:", response);
      
      let bannersData = [];
      if (response && response.status === true && response.data) {
        bannersData = response.data;
      } else if (Array.isArray(response)) {
        bannersData = response;
      } else if (response?.data && Array.isArray(response.data)) {
        bannersData = response.data;
      }
      
      setBanners(bannersData);
    } catch (err) {
      console.error("Error fetching banners:", err);
      setError(err.message || "Failed to fetch banners");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  // Filter banners
  const filteredBanners = banners.filter(banner =>
    banner.title?.toLowerCase().includes(search.toLowerCase())
  );

  // Pagination
  const totalPages = Math.ceil(filteredBanners.length / itemsPerPage);
  const paginatedBanners = filteredBanners.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // ✅ Toggle hide/show status
  const toggleStatus = async (banner) => {
    const newHideValue = banner.hide === 0 ? 1 : 0;
    setActionLoading(true);
    try {
      const payload = {
        id: banner.id,
        hide: newHideValue
      };
      
      const response = await postData("banners/update_webbanner", payload);
      
      if (response && response.status === true) {
        setBanners(prev => prev.map(b => 
          b.id === banner.id ? { ...b, hide: newHideValue } : b
        ));
      } else {
        alert(response?.message || "Failed to update status");
        fetchBanners();
      }
    } catch (error) {
      console.error("Toggle status error:", error);
      alert("Failed to update status: " + error.message);
    } finally {
      setActionLoading(false);
    }
  };

  // ✅ Delete banner
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this banner?")) return;
    
    setActionLoading(true);
    try {
      const response = await postData("banners/delete_webbanner", { id });
      
      if (response && response.status === true) {
        setBanners(prev => prev.filter(b => b.id !== id));
        alert("Banner deleted successfully");
      } else {
        alert(response?.message || "Failed to delete banner");
        fetchBanners();
      }
    } catch (error) {
      console.error("Delete error:", error);
      alert("Failed to delete banner: " + error.message);
    } finally {
      setActionLoading(false);
    }
  };

  const handleEdit = (banner) => {
    setEditingBanner(banner);
    setIsDialogOpen(true);
  };

  const handleView = (banner) => {
    alert(`📋 Banner Details\n\nName: ${banner.title}\nStatus: ${banner.hide === 0 ? "Visible" : "Hidden"}`);
  };

  const handleAddBanner = () => {
    setEditingBanner(null);
    setIsDialogOpen(true);
  };

  // ✅ Save banner
  const handleSaveBanner = async (bannerData, existingBanner) => {
    setActionLoading(true);
    try {
      let response;
      
      if (existingBanner) {
        // Update existing banner
        const payload = {
          id: existingBanner.id,
          title: bannerData.title,
          hide: bannerData.hide,
          pic: bannerData.pic || existingBanner.pic,
        };
        
        response = await postData("banners/update_webbanner", payload);
      } else {
        // Create new banner
        const payload = {
          title: bannerData.title,
          hide: bannerData.hide,
          pic: bannerData.pic || "",
        };
        
        response = await postData("banners/add_webbanner", payload);
      }
      
      if (response && response.status === true) {
        fetchBanners();
        alert(existingBanner ? "Banner updated successfully" : "Banner added successfully");
      } else {
        alert(response?.message || "Failed to save banner");
      }
    } catch (error) {
      console.error("Save banner error:", error);
      alert("Failed to save banner: " + error.message);
    } finally {
      setActionLoading(false);
    }
  };

  const styles = {
    container: { background: "transparent", fontFamily: "'Segoe UI', 'DM Sans', sans-serif", padding: "20px 24px" },
    header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px", flexWrap: "wrap", gap: "16px" },
    searchWrapper: { position: "relative", flex: 1, maxWidth: "350px" },
    searchIcon: { position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#3b82f6" },
    searchInput: {
      width: "100%", padding: "10px 12px 10px 38px", background: isDark ? "#141824" : "#ffffff",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "10px",
      fontSize: "13px", color: isDark ? "#f1f5f9" : "#1e293b", outline: "none",
    },
    addBtn: { display: "flex", alignItems: "center", gap: "6px", padding: "10px 20px", background: "#4a6cf7", color: "#fff", border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: 600, cursor: "pointer" },
    refreshBtn: { display: "flex", alignItems: "center", gap: "6px", padding: "10px 16px", background: isDark ? "#1e2740" : "#e2e8f0", color: isDark ? "#94a3b8" : "#64748b", border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: 500, cursor: "pointer" },
    tableWrapper: { background: isDark ? "#141824" : "#ffffff", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "12px", overflow: "auto" },
    table: { width: "100%", borderCollapse: "collapse", minWidth: "700px" },
    th: { padding: "14px 16px", textAlign: "left", fontSize: "12px", fontWeight: 700, color: "#3b82f6", borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", background: isDark ? "#0f1520" : "#f8fafc", whiteSpace: "nowrap" },
    td: { padding: "14px 16px", fontSize: "13px", color: isDark ? "#e2e8f0" : "#1e293b", borderBottom: isDark ? "1px solid #1a2035" : "1px solid #f1f5f9" },
    actions: { display: "flex", gap: "8px" },
    actionBtn: { background: "none", border: "none", cursor: "pointer", padding: "4px", color: isDark ? "#64748b" : "#94a3b8", display: "flex", alignItems: "center", justifyContent: "center", transition: "color 0.2s" },
    titleCell: { fontWeight: 600, color: isDark ? "#f1f5f9" : "#1e293b", maxWidth: "200px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
    pagination: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderTop: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", background: isDark ? "#0f1520" : "#f8fafc" },
    pageBtn: (disabled, isActive) => ({
      width: "32px", height: "32px", borderRadius: "6px",
      border: isActive ? "1px solid #3b82f6" : (isDark ? "1px solid #1e2740" : "1px solid #e2e8f0"),
      background: isActive ? "#1e3a8a" : (isDark ? "#141824" : "#ffffff"),
      color: isActive ? "#93c5fd" : (disabled ? (isDark ? "#2d3a55" : "#cbd5e1") : (isDark ? "#94a3b8" : "#64748b")),
      cursor: disabled ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center",
    }),
    emptyState: { padding: "60px", textAlign: "center", color: isDark ? "#64748b" : "#94a3b8", fontSize: "14px" },
    loadingState: { padding: "60px", textAlign: "center", color: isDark ? "#64748b" : "#94a3b8" },
  };

  return (
    <div style={styles.container}>
      <style>{`@keyframes fadeIn { from { opacity: 0; transform: scale(0.96); } to { opacity: 1; transform: scale(1); } } @keyframes spin { to { transform: rotate(360deg); } }`}</style>
      
      <div style={styles.header}>
        <div style={styles.searchWrapper}>
          <span style={styles.searchIcon}><SearchIcon /></span>
          <input type="text" style={styles.searchInput} placeholder="Search banners..." value={search} onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }} />
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <button style={styles.refreshBtn} onClick={fetchBanners} disabled={loading}><RefreshIcon /> Refresh</button>
          <button style={styles.addBtn} onClick={handleAddBanner}><PlusIcon /> Add Banner</button>
        </div>
      </div>

      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>ID</th>
              <th style={styles.th}>Image</th>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} style={styles.loadingState}><SpinnerIcon /> Loading banners...</td></tr>
            ) : error ? (
              <tr><td colSpan={5} style={styles.loadingState}>
                <div>Error: {error}</div>
                <button onClick={fetchBanners} style={{ marginTop: "12px", padding: "6px 16px", borderRadius: "8px", border: "none", background: "#3b82f6", color: "#fff", cursor: "pointer" }}>Retry</button>
              </td></tr>
            ) : paginatedBanners.length === 0 ? (
              <tr><td colSpan={5} style={styles.emptyState}>No banners found</td></tr>
            ) : (
              paginatedBanners.map((banner) => (
                <tr key={banner.id}>
                  <td style={styles.td}>{banner.id}</td>
                  <td style={styles.td}><ImagePlaceholder isDark={isDark} imageUrl={banner.pic} title={banner.title} /></td>
                  <td style={{ ...styles.td, ...styles.titleCell }} title={banner.title}>{banner.title}</td>
                  <td style={styles.td}><StatusBadge hide={banner.hide} isDark={isDark} /></td>
                  <td style={styles.td}>
                    <div style={styles.actions}>
                      <button style={styles.actionBtn} onClick={() => handleView(banner)} title="View" disabled={actionLoading}><EyeIcon /></button>
                      <button style={styles.actionBtn} onClick={() => handleEdit(banner)} title="Edit" disabled={actionLoading}><EditIcon /></button>
                      <button style={styles.actionBtn} onClick={() => toggleStatus(banner)} title={banner.hide === 0 ? "Hide" : "Show"} disabled={actionLoading}>
                        {banner.hide === 0 ? <HideIcon /> : <ShowIcon />}
                      </button>
                      <button style={styles.actionBtn} onClick={() => handleDelete(banner.id)} title="Delete" disabled={actionLoading}><DeleteIcon /></button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {!loading && filteredBanners.length > itemsPerPage && (
        <div style={styles.pagination}>
          <span style={{ fontSize: "12px", color: isDark ? "#64748b" : "#94a3b8" }}>
            Showing {Math.min((currentPage - 1) * itemsPerPage + 1, filteredBanners.length)} to {Math.min(currentPage * itemsPerPage, filteredBanners.length)} of {filteredBanners.length} banners
          </span>
          <div style={{ display: "flex", gap: "6px" }}>
            <button style={styles.pageBtn(currentPage === 1, false)} onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}>‹</button>
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5) pageNum = i + 1;
              else if (currentPage <= 3) pageNum = i + 1;
              else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + i;
              else pageNum = currentPage - 2 + i;
              return pageNum <= totalPages && (
                <button key={pageNum} style={styles.pageBtn(false, currentPage === pageNum)} onClick={() => setCurrentPage(pageNum)}>{pageNum}</button>
              );
            })}
            <button style={styles.pageBtn(currentPage === totalPages, false)} onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}>›</button>
          </div>
        </div>
      )}

      {isDialogOpen && (
        <AddWebBannerDialog
          isDark={isDark}
          onClose={() => { setIsDialogOpen(false); setEditingBanner(null); }}
          onSave={handleSaveBanner}
          editingBanner={editingBanner}
        />
      )}
    </div>
  );
};

export default WebBanners;